import React, { Component } from "react";
import { Col, Row, Button, Image, Spinner } from "react-bootstrap";
import { updateTutorSettings } from "../../../apis/tutors";
import { connect } from "react-redux";
import { getSubjectWithCategory } from "../../../apis/tutorList";
import { TutorSettingAction } from "./../../../redux/actions/index";
import { countBy } from "lodash";

class TutorSettingBioAndSub extends Component {
  constructor() {
    super();

    this.state = {
      allTutorInfo: {},
      modeofTeaching: [],
      teachingCertificate: [],
      profileBio: [],
      employmentData: [],
      educationData: [],
      editPanel: "",
      tutorBioLoader: false,
      count: 0,
    };
  }
  makeSubjectData = (subject) => {
    let allSubject = {};
    subject.map((sub, i) => {
      if (allSubject.hasOwnProperty(sub.category)) {
        if (allSubject[sub.category].hasOwnProperty(sub.subject)) {
          if (allSubject[sub.category][sub.subject]?.length) {
            allSubject[sub.category][sub.subject].push(sub.level);
          } else {
            allSubject[sub.category][sub.subject] = [];
            allSubject[sub.category][sub.subject].push(sub.level);
          }
        } else {
          allSubject[sub.category][sub.subject] = [];
          allSubject[sub.category][sub.subject].push(sub.level);
        }
      } else {
        allSubject[sub.category] = {};
        allSubject[sub.category][sub.subject] = [];
        allSubject[sub.category][sub.subject].push(sub.level);
      }
    });
    return allSubject;
  };

  isExistObj = (tutorSettingSubject) => {
    let exist = [];
    if (tutorSettingSubject) {
      Object.keys(tutorSettingSubject).map((subjectObj, title) => {
        return Object.keys(tutorSettingSubject[subjectObj]).map((wSub) =>
          wSub
            ? tutorSettingSubject[subjectObj][wSub].length
              ? tutorSettingSubject[subjectObj][wSub].map((sub) =>
                  exist.push(true)
                )
              : exist.push(false)
            : exist.push(false)
        );
      });
      return exist;
    } else return [false];
  };

  makeSubjectDataforRendor = (res) => {
    let user = JSON.parse(localStorage.getItem("userDetail"));
    let user_id = user.user.userId;
    let { modeofTeaching } = this.state;
    let tutorSubjectObj = {};
    const { tutorSettingSubject } = this.props;
    console.log("res====", res);
    if (res) {
      modeofTeaching.push({
        name: "Venue Preference",
        value:
          !res.canTeachInperson && res.canTeachOnline
            ? "Online"
            : res.canTeachInperson && !res.canTeachOnline
            ? "In-person"
            : res.canTeachInperson && res.canTeachOnline
            ? "Online and In-person"
            : "No Online and In-person",
      });
      this.setState({
        modeofTeaching,
        canTeachInperson: res.canTeachInperson,
        canTeachOnline: res.canTeachOnline,
      });
    }
    if (this.isExistObj(tutorSettingSubject).indexOf(true) === -1) {
      getSubjectWithCategory({
        id: user_id,
      })
        .then((res) => {
          tutorSubjectObj = this.makeSubjectData(res.data);
          this.props.TutorSettingSubjectData(tutorSubjectObj);
          this.setState({
            tutorSubjectObj,
            tutorBioLoader: false,
          });
        })
        .catch((err) => console.log(err));
    } else {
      this.setState({
        tutorSubjectObj: tutorSettingSubject,
        tutorBioLoader: false,
      });
    }
  };
  makeProfileBioDataforRendor = (res) => {
    let { profileBio } = this.state;
    profileBio = [];
    profileBio.push({ name: "Profile tagline", value: res?.tagline });
    profileBio.push({ name: "About yourself", value: res?.bio });
    profileBio.push({ name: "Teaching style", value: res?.teachingStyle });
    this.setState({
      profileBio,
    });
  };

  makeCertificatesDataforRendor = (res) => {
    let { teachingCertificate } = this.state;
    if (res?.certificates?.doctoralDegree) {
      Object.keys(res.certificates).map((cert) => {
        if (
          res.certificates?.[cert].length &&
          cert === "teachingAndEducation"
        ) {
          return res.certificates?.[cert].map((certiValue) => {
            teachingCertificate.push({
              name: "Teaching and education certificate",
              value: certiValue,
            });
          });
        }
        if (res.certificates?.[cert].length && cert === "doctoralDegree") {
          return res.certificates?.[cert].map((degreeValue) => {
            teachingCertificate.push({
              name: "Doctoral degree",
              value: degreeValue,
            });
          });
        }
      });
      this.setState({
        teachingCertificate,
      });
    } else {
      return;
    }
  };
  makeEducationAndWorkDataforRendor = (data) => {
    var educationData = data?.education?.sort(function (a, b) {
      return new Date(b.startDate) - new Date(a.startDate);
    });
    var employmentData = data?.employment?.sort(function (a, b) {
      return new Date(b.startDate) - new Date(a.startDate);
    });
    this.setState({
      educationData,
      employmentData,
    });
  };
  makeRateDataforRendor = (data) => {
    let hourlyRate = [];
    hourlyRate.push({ name: "Your hourly rate", value: data?.hourlyRate });
    this.setState({ hourlyRate });
  };

  componentDidMount = () => {
    this.setState({
      tutorBioLoader: true,
    });
    const { tutorSettingData } = this.props;
    this.makeSubjectDataforRendor(tutorSettingData?.tutorDetails);
    this.makeCertificatesDataforRendor(tutorSettingData?.tutorDetails);
    this.makeProfileBioDataforRendor(tutorSettingData?.tutorDetails);
    this.makeEducationAndWorkDataforRendor(tutorSettingData?.tutorDetails);
    this.makeRateDataforRendor(tutorSettingData?.tutorDetails);
    this.setState({
      tutorSettingDataState: { ...tutorSettingData },
    });
  };

  componentDidUpdate = (prevProps) => {
    const { tutorSettingData } = this.props;
    const { tutorSettingDataState } = this.state;
    if (
      (!tutorSettingDataState?.userId && tutorSettingData?.userId) ||
      prevProps?.tutorSettingData?.userId !== tutorSettingData?.userId
    ) {
      this.setState({
        tutorBioLoader: true,
      });
      this.makeSubjectDataforRendor(tutorSettingData?.tutorDetails);
      this.makeCertificatesDataforRendor(tutorSettingData?.tutorDetails);
      this.makeProfileBioDataforRendor(tutorSettingData?.tutorDetails);
      this.makeEducationAndWorkDataforRendor(tutorSettingData?.tutorDetails);
      this.makeRateDataforRendor(tutorSettingData?.tutorDetails);
      this.setState({
        tutorSettingDataState: { ...tutorSettingData },
        tutorBioLoader: false,
      });
    }
  };

  onUpdateAllSettings = () => {
    this.setState({
      loader: true,
    });
    const { tutorSettingDataState, tutorSubjectObj } = this.state;
    let updateTutorObj = { ...tutorSettingDataState };
    let tutorDetails = { ...updateTutorObj.tutorDetails };
    delete updateTutorObj.tutorDetails;
    updateTutorObj = { ...updateTutorObj, ...tutorDetails };
    updateTutorObj.subjects = this.props.tutorSettingDataState;

    let updateSettingParam = {
      updateSetting: {
        bio: updateTutorObj.bio,
        tagline: updateTutorObj.tagline,
        teachingStyle: updateTutorObj.teachingStyle,
        subjects: tutorSubjectObj,
        hourlyRate: updateTutorObj.hourlyRate,
        employment: updateTutorObj.employment,
        education: updateTutorObj.education,
        certificates: updateTutorObj.certificates,
        profileStatus: updateTutorObj.profileStatus,
        offlineDetails:
          updateTutorObj?.profileStatus !== 0
            ? updateTutorObj.offlineDetails
            : {},
        addressRaw: updateTutorObj.addressRaw,
        address: updateTutorObj.address,
        canTeachInperson: updateTutorObj.canTeachInperson,
        canTeachOnline: updateTutorObj.canTeachOnline,
        modeOfTeaching: updateTutorObj.modeOfTeaching,
        willignessToTravel: updateTutorObj.willignessToTravel,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
        this.props.history.push("/tutor-dashboard/profile");
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
  };
  render() {
    const {
      modeofTeaching,
      profileBio,
      educationData,
      employmentData,
      hourlyRate,
      tutorSubjectObj,
      tutorBioLoader,
      tutorSettingDataState,
      loader,
      showMore,
      count,
      moreDataEdu,
      moreDataWork,
      canTeachOnline,
      canTeachInperson,
    } = this.state;
    let subjectArray = [];
    console.log("modeofTeaching", modeofTeaching);

    if (tutorSubjectObj)
      Object.keys(tutorSubjectObj).map((subjectObj, title) => {
        return Object.keys(tutorSubjectObj[subjectObj]).map((wSub) => {
          subjectArray.push({
            wSub,
            subjectArray: tutorSubjectObj[subjectObj][wSub],
          });
        });
      });

    return (
      <div className="container">
        <div className="tutor-setting-BioAndSub">
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="flex-end-center btn-session"
          >
            <Button
              className="green-fill-btn"
              onClick={() => this.props.history.push("/tutor-dashboard/profile")}
            >
              Preview Profile
            </Button>
            <Button className="green-unfill-btn">Set availabilty</Button>
          </Col>

          {console.log("===", tutorSubjectObj && Object.keys(tutorSubjectObj))}
          <Row style={{ margin: "0px" }}>
            <SettingSubAndBioPanel
              tutorBioLoader={tutorBioLoader}
              settingTitle={"Taught subjects"}
              tutorSettingArray={subjectArray}
              nameProperty="level"
              valueProperty="subject"
              ObjectType={true}
              onShowMoreFunc={() =>
                this.setState({
                  showMore: true,
                })
              }
              count={count}
              showMore={showMore}
              countSub={
                count < 3
                  ? () =>
                      this.setState({
                        ...this.state,
                        count: count + 1,
                      })
                  : () => {}
              }
              onEdit={() => {
                this.props.history.push(
                  "/tutor-dashboard/TutorSettingBioAndSub/edit-subject"
                );
              }}
            />
            {!showMore ? (
              <div
                className="green-txt"
                style={{
                  fontSize: "16px",
                  width: "100%",
                  borderBottom: "1px solid #cccccc",
                  paddingBottom: "36.5px",
                }}
                onClick={() =>
                  this.setState({
                    showMore: true,
                  })
                }
              >
                + More
              </div>
            ) : (
              ""
            )}

            <SettingSubAndBioPanel
              tutorBioLoader={tutorBioLoader}
              settingTitle={"Mode of tutoring"}
              tutorSettingArray={modeofTeaching}
              nameProperty="name"
              valueProperty="value"
              onEdit={() => {
                this.props.history.push(
                  "/tutor-dashboard/TutorSettingBioAndSub/ModeofTutorSetting"
                );
              }}
            />
            {/* <SettingSubAndBioPanel
          tutorBioLoader={tutorBioLoader}
            settingTitle={"Teaching, education or doctoral qualifications"}
            tutorSettingArray={teachingCertificate}
            nameProperty="name"
            valueProperty="value"
          /> */}
            <SettingSubAndBioPanel
              tutorBioLoader={tutorBioLoader}
              settingTitle={"Profile bio"}
              tutorSettingArray={profileBio}
              nameProperty="name"
              valueProperty="value"
              para={true}
              onEdit={() => {
                this.props.history.push(
                  "/tutor-dashboard/TutorSettingBioAndSub/ProfileBioSetting"
                );
              }}
            />
            {educationData?.length ? (
              <SettingSubAndBioPanel
                tutorBioLoader={tutorBioLoader}
                settingTitle={"Education"}
                tutorSettingArray={educationData}
                nameProperty="schoolName"
                valueProperty="startDate"
                endDate="endDate"
                subTitle="degree"
                onEdit={() => {
                  this.props.history.push(
                    "/tutor-dashboard/TutorSettingBioAndSub/EducationSetting"
                  );
                }}
                onMoreData={() =>
                  this.setState({
                    moreDataEdu: true,
                  })
                }
                moreData={moreDataEdu}
              />
            ) : (
              ""
            )}
            {employmentData?.length ? (
              <SettingSubAndBioPanel
                tutorBioLoader={tutorBioLoader}
                settingTitle={"Works history"}
                tutorSettingArray={employmentData}
                nameProperty="employerName"
                valueProperty="startDate"
                endDate="endDate"
                subTitle="jobTitle"
                onEdit={() => {
                  this.props.history.push(
                    "/tutor-dashboard/TutorSettingBioAndSub/WorkSetting"
                  );
                }}
                isCurrentJob={"isCurrentJob"}
                onMoreData={() =>
                  this.setState({
                    moreDataWork: true,
                  })
                }
                moreData={moreDataWork}
              />
            ) : (
              ""
            )}
            <SettingSubAndBioPanel
              tutorBioLoader={tutorBioLoader}
              settingTitle={"Set your rate"}
              tutorSettingArray={hourlyRate}
              nameProperty="name"
              valueProperty="value"
              valueImage={require("./../../../assets/icons/pound-black.png")}
              onEdit={() => {
                this.props.history.push(
                  "/tutor-dashboard/TutorSettingBioAndSub/HourlyRateSetting"
                );
              }}
            />
            <SettingSubAndBioPanel
              tutorBioLoader={tutorBioLoader}
              settingTitle={"Profile status"}
              noData={true}
              liveSign={
                tutorSettingDataState?.tutorDetails?.profileStatus === 0
                  ? require("./../../../assets/icons/greenCircle.svg")
                  : require("./../../../assets/icons/away.svg")
              }
              simpleTxt={
                tutorSettingDataState?.tutorDetails?.profileStatus === 0
                  ? "Live"
                  : "Offline"
              }
              onEdit={() => {
                this.props.history.push(
                  "/tutor-dashboard/TutorSettingBioAndSub/ProfileStatus"
                );
              }}
            />
            <SettingSubAndBioPanel
              tutorBioLoader={tutorBioLoader}
              settingTitle={"Who can see your profile and book you?"}
              noData={true}
              isEditBtnHide={true}
              simpleTxt={"Everyone on Askademia."}
              isBorderHide={true}
            />
            {/* <Button
            style={{ marginTop: "40px", marginBottom: "40px" }}
            className="green-save-btn"
            onClick={this.onUpdateAllSettings}
          >
            {loader ? <Spinner animation="border" /> : "Update"}
          </Button> */}
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    UserReducer: { user },
    TutorSettingReducer: { tutorSettingData, tutorSettingSubject },
  } = state;

  return {
    user,
    tutorSettingData,
    tutorSettingSubject,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    TutorSettingSubjectData: (payload) => {
      dispatch(TutorSettingAction.TutorSettingSubjectData(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TutorSettingBioAndSub);

function SettingSubAndBioPanel({
  tutorBioLoader,
  settingTitle,
  tutorSettingArray,
  nameProperty,
  valueProperty,
  valueImage,
  endDate,
  subTitle,
  para,
  noData,
  isEditBtnHide,
  liveSign,
  simpleTxt,
  ObjectType,
  onEdit,
  isCurrentJob,
  count,
  showMore,
  countSub,
  moreData,
  isBorderHide,
  onMoreData,
}) {
  return (
    <div style={{ width: "100%" }}>
      <Col
        lg={12}
        md={12}
        sm={12}
        xs={12}
        className="setting-bio-and-sub-col flex-between-center"
      >
        <div className="setting-title-div">{settingTitle}</div>
        {!isEditBtnHide ? (
          <Button className="green-unfill-btn" onClick={onEdit}>
            Edit
          </Button>
        ) : (
          ""
        )}
      </Col>
      {tutorBioLoader ? (
        <Col lg={12} md={12} sm={12} xs={12}>
          <div className="flex-center-center">
            <Spinner
              animation="border"
              style={{ width: "50px", height: "50px" }}
            />
          </div>
        </Col>
      ) : noData ? (
        <Col
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="flex-between-center setting-panel-col"
          style={{ borderBottom: !isBorderHide ? "1px solid #ccc" : "none" }}
        >
          <div style={{ marginTop: subTitle ? "30px" : "" }}>
            <div className="name-div">
              {liveSign ? (
                <Image
                  style={{ width: "13px", marginRight: "25px" }}
                  src={liveSign}
                />
              ) : (
                ""
              )}{" "}
              {simpleTxt}
            </div>
          </div>
        </Col>
      ) : ObjectType ? (
        tutorSettingArray?.length &&
        tutorSettingArray.map((subjectObj, index) => {
          return index < 2 ? (
            subjectObj?.subjectArray?.length ? (
              <div key={index}>
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="flex-between-center setting-panel-col"
                  // key={index}
                  style={{
                    borderBottom:
                      index !== 1 || showMore ? "1px solid #ccc" : "",
                    paddingBottom: index !== 1 || showMore ? "22px" : "0px",
                  }}
                >
                  <div className="name-div">
                    {subjectObj.wSub.charAt(0).toUpperCase() +
                      subjectObj.wSub.slice(1)}
                  </div>
                  <div className="flex-center">
                    {subjectObj?.subjectArray.map((level, i) => {
                      let data = subjectObj?.subjectArray;
                      return (
                        <div
                          className="value-div"
                          style={{
                            marginLeft: "3px",
                          }}
                          key={i}
                        >
                          {i === data.length - 1 ? level : `${level}, `}
                        </div>
                      );
                    })}
                  </div>
                </Col>
              </div>
            ) : null
          ) : showMore && subjectObj?.subjectArray?.length ? (
            <div>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="flex-between-center setting-panel-col"
                // key={index}
                style={{ borderBottom: "1px solid #ccc" }}
              >
                <div className="name-div">
                  {subjectObj.wSub.charAt(0).toUpperCase() +
                    subjectObj.wSub.slice(1)}
                </div>
                <div className="flex-center">
                  {subjectObj?.subjectArray.map((level, i) => {
                    let data = subjectObj?.subjectArray;
                    return (
                      <div
                        className="value-div"
                        style={{
                          marginLeft: "3px",
                        }}
                        key={i}
                      >
                        {i === data.length - 1 ? level : `${level}, `}
                      </div>
                    );
                  })}
                </div>
              </Col>
            </div>
          ) : null;
        })
      ) : tutorSettingArray?.length ? (
        !para ? (
          <div>
            {tutorSettingArray.map((value, i) =>
              i < 2 ? (
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="flex-between-center setting-panel-col"
                  key={i}
                  style={{
                    borderBottom: i !== 1 || moreData ? "1px solid #ccc" : "",
                    paddingBottom: i !== 1 || moreData ? "35px" : "5px",
                  }}
                >
                  <div style={{ marginTop: subTitle ? "30px" : "" }}>
                    <div className="name-div">{value[nameProperty]}</div>
                    {subTitle ? (
                      <div className="name-div">{value[subTitle]}</div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="value-div">
                    {valueImage ? (
                      <Image
                        style={{ width: "17px", paddingBottom: "3px" }}
                        src={valueImage}
                      />
                    ) : (
                      ""
                    )}
                    {valueProperty === "startDate"
                      ? `${
                          value[valueProperty]
                            ? new Date(value[valueProperty]).getFullYear()
                            : ""
                        } - ${
                          value[isCurrentJob ? "isCurrentJob" : "isCurrent"]
                            ? "present"
                            : value[endDate]
                            ? new Date(value[endDate]).getFullYear()
                            : ""
                        }`
                      : value[valueProperty]}
                  </div>
                </Col>
              ) : moreData ? (
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="flex-between-center setting-panel-col"
                  key={i}
                  style={{ borderBottom: "1px solid #ccc" }}
                >
                  <div style={{ marginTop: subTitle ? "30px" : "" }}>
                    <div className="name-div">{value[nameProperty]}</div>
                    {subTitle ? (
                      <div className="name-div">{value[subTitle]}</div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="value-div">
                    {valueImage ? (
                      <Image
                        style={{ width: "17px", paddingBottom: "3px" }}
                        src={valueImage}
                      />
                    ) : (
                      ""
                    )}
                    {valueProperty === "startDate"
                      ? `${
                          value[valueProperty]
                            ? new Date(value[valueProperty]).getFullYear()
                            : ""
                        } - ${
                          value[isCurrentJob ? "isCurrentJob" : "isCurrent"]
                            ? "present"
                            : value[endDate]
                            ? new Date(value[endDate]).getFullYear()
                            : ""
                        }`
                      : value[valueProperty]}
                  </div>
                </Col>
              ) : (
                ""
              )
            )}
            {!moreData &&
            tutorSettingArray.length > 2 &&
            valueProperty === "startDate" ? (
              <div
                className="green-txt"
                style={{
                  fontSize: "14px",
                  borderBottom: "1px solid #cccccc",
                  paddingBottom: "35.5px",
                }}
                onClick={onMoreData}
              >
                + More
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          tutorSettingArray.map((value, i) => (
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="setting-panel-col"
              key={i}
              style={{ borderBottom: "1px solid #ccc" }}
            >
              <div className="para-title-bold">{value[nameProperty]}</div>
              <div className="value-para">{value[valueProperty]}</div>
            </Col>
          ))
        )
      ) : (
        <span className="no-data">no data</span>
      )}
    </div>
  );
}
